import React, { JSX } from 'react';
import {
    Edit,
    TabbedForm,
    TextInput,
    required,
    SelectInput,
    ReferenceField,
    WithRecord
} from 'react-admin';
import {
    Box,
    Stack
} from '@mui/material'
import { enterpriseRequestStatus } from "../../defaults/defaults";
import { EnterpriseRequest } from "../../types/entities";
import { ConversationPanel } from "./components/Sales/ConversationPanel";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

/**
 * Two tabs rather than two columns, matching `ContactFormEdit` (user, 2026-09-08). The request and
 * the conversation answering it were crowding each other side by side.
 */
export const EnterpriseRequestEdit: () => JSX.Element = (): JSX.Element => {
    return (
        <Edit redirect={ false }>
            <TabbedForm>
                <TabbedForm.Tab label="Request">
                    <Stack spacing={ 1 } sx={ { width: '100%', maxWidth: 900 } }>
                        <SelectInput name="status"
                                     source="status"
                                     choices={ enterpriseRequestStatus }
                                     validate={[required()]}
                                     fullWidth />
                        <TextInput name="name" source="name" validate={[required()]} fullWidth />
                        <TextInput name="email" source="email" validate={[required()]} fullWidth />
                        <Box sx={ { width: '100%', display: 'flex', justifyContent: 'space-between' } } >
                            <span>{ "Customer Account" }</span>
                            <ReferenceField source="customerAccount" reference="customer_accounts" label="Customer Account">
                                <span>{ "View Account" }</span>
                            </ReferenceField>
                        </Box>
                        <TextInput name="telephone" source="telephone" validate={[required()]} fullWidth />
                        <TextInput name="website"
                                   helperText="Include the https:// in the domain"
                                   source="website"
                                   validate={[required()]}
                                   fullWidth />
                        <TextInput name="message"
                                   source="message"
                                   readOnly
                                   fullWidth
                                   multiline
                                   rows={16}/>
                    </Stack>
                    {/* Inside a tab, not beside them: TabbedFormTabs clones every direct child into the
                        tab bar. One tab is enough - react-admin mounts them all and hides the
                        inactive ones, so the whole form is registered from here. */}
                    <ChatFieldBridge />
                </TabbedForm.Tab>

                <TabbedForm.Tab label="Conversation">
                    { /* Same panel as the contact form screen; only the id differs. The old JSON
                         notes column is shown read-only inside it as earlier notes. */ }
                    <WithRecord label=" " render={
                        (record: EnterpriseRequest): JSX.Element => (
                            <ConversationPanel
                                subject={ { enterpriseRequest: Number(record.id) } }
                                defaultSubject="Your NokNok enterprise request"
                            />
                        )
                    } />
                </TabbedForm.Tab>
            </TabbedForm>
        </Edit>
    );
}
